import { type ReactNode, useEffect } from 'react';

import { useTheme } from '@/shared/store/hooks/useTheme';

interface ThemeProviderProps {
  readonly children: ReactNode;
}

/**
 * Provider de tema claro/escuro.
 *
 * Lê o átomo `themeAtom` via `useTheme()` e aplica a classe CSS
 * correspondente no elemento `<html>`, que o Tailwind usa para
 * ativar o modo escuro via `dark:` prefix.
 *
 * Persiste a preferência via `atomWithStorage` (localStorage).
 */
export function ThemeProvider({ children }: ThemeProviderProps) {
  const { theme } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);
  }, [theme]);

  return <>{children}</>;
}
